module.exports = __webpack_public_path__ + "img/jiejueBanner.be389e04.png";